import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormSection } from 'omni-package-react-core';
import { PersonalInformation } from '../../../../interfaces/PersonalInformation';
import Name from '../../../../components/_Name';
import Gender from '../../../../components/_Gender';
import BirthDate from '../../../../components/_BirthDate';
import CareOf from '../../../../components/_CareOf';

export interface AboutYouSectionProps {
  personalInfo: PersonalInformation;
}

const AboutYouSection: FC<AboutYouSectionProps> = ({ personalInfo }) => {
  const { t } = useTranslation('PersonalInformationsFormPage');

  return (
    <FormSection pb={36} title={t('aboutYouLabel')}>
      <Name personalInfo={personalInfo} withButton={false} />
      <BirthDate personalInfo={personalInfo} />
      <Gender personalInfo={personalInfo} />
      <CareOf personalInfo={personalInfo} />
    </FormSection>
  );
};

export default (AboutYouSection);
